<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <UserWebService />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import UserWebService from '@/components/settings/app-frotix-registers/userwebservice/Add'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'UserWebServiceView',
  components: {
    PageTitle,
    PageRowWrapper,
    UserWebService,
    LoadingPage
  }
}
</script>
